module.exports = __webpack_public_path__ + "media/images/limits-fill-topbar-ab68a983c7d501a2d00bbe4d9fe635f0.svg";